import type { TripPlannerSurfaceActivityEntry } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityEntryTypes'
import { boundActivityDisplayText } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityDisplayText'

export function buildLocationSuggestionOpenedActivityEntry(title: string): TripPlannerSurfaceActivityEntry {
  return {
    kind: 'location_suggestion_opened',
    label: 'Opened suggested location',
    displayText: boundActivityDisplayText(`Opened suggestion "${title}"`),
    sourcePath: 'trip_planner.chat.suggestion_card',
    dataClassification: 'personalised_surface',
    occurredAt: new Date().toISOString(),
  }
}
